/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2024-10-18 16:55:09
 * @LastEditors: linxi
 * @LastEditTime: 2025-04-03 17:59:43
 */
import { SearchOutlined } from '@ant-design/icons'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  DatePicker,
  Checkbox,
  Input,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTenantCountyCode } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import {
  DateRangeType,
  DateSelect,
} from '../../../../compnents/form/DateSelect'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
} from '../../../../models/datetime'

const { Option } = Select

export const Query = (props: {
  onValueChange: (params: any) => void
  export: () => void
}): ReactElement => {
  const [form] = Form.useForm()

  const { RangePicker } = DatePicker

  const dispatch = useDispatch<RootDispatch>()

  const [flag, setFlag] = useState<any>()

  const [dates, setDates] = useState<any>([])

  const disabledSixMonthDate: any = (current: any) => {
    const tooLate = dates?.[0] && current.diff(dates?.[0], 'months') > 6
    const tooEarly = dates?.[1] && dates?.[1].diff(current, 'months') > 6
    return tooEarly || tooLate
  }

  // 处理日期变化的函数
  const onDateChange = (values: any) => {
    setDates(values)
  }
  return (
    <Form
      form={form}
      onFinish={(values) => {
        const startTime = moment(values?.timeHead).startOf('day')?.format(
          DateTimeFormatSimpleOnlyOne
        )
        const endTime = moment(values?.timeTail)
          .endOf('day')
          .format(DateTimeFormatSimpleOnlyOne)
        props.onValueChange({
          ...values,
          startDate: startTime,
          endDate: endTime,
          timeHead: undefined,
          timeTail: undefined,
        })
      }}
    >
      <Row style={{ marginLeft: 4, marginBottom: 10 }} justify='space-between'>
        <Space>
          <Form.Item name='param' noStyle>
            <Input
              placeholder='患者姓名/药品名/追溯码'
              autoComplete='off'
              prefix={<SearchOutlined />}
              allowClear
              onChange={form.submit}
              style={{
                width: '14rem',
              }}
            />
          </Form.Item>
          <Form.Item name='businessType' label='' noStyle>
            <Select
              allowClear
              placeholder='业务名称'
              style={{
                width: '8.6rem',
              }}
              onChange={(e) => {
                setFlag(e)
                form.submit()
              }}
            >
              <Option value={1}>发药/退药上传</Option>
              <Option value={2}>入库上传</Option>
            </Select>
          </Form.Item>
          <Form.Item name='medicalUploadStatus' label='' noStyle>
            <Select
              allowClear
              placeholder='医保上传状态'
              style={{
                width: '9rem',
              }}
              onChange={form.submit}
            >
              {flag == 1 ? (
                <>
                  <Option value={0}>未上传</Option>
                  <Option value={1}>发药已上传</Option>
                  <Option value={2}>退药已上传</Option>
                </>
              ) : flag == 2 ? (
                <>
                  <Option value={0}>未上传</Option>
                  <Option value={1}>入库已上传</Option>
                </>
              ) : (
                <>
                  <Option value={0} disabled>
                    请先选择业务类型
                  </Option>
                </>
              )}
            </Select>
          </Form.Item>
          <Form.Item name='isSplit' label='' noStyle>
            <Select
              allowClear
              placeholder='是否拆零'
              style={{ width: '7rem' }}
              onChange={form.submit}
            >
              <Option value={1}>是</Option>
              <Option value={0}>否</Option>
            </Select>
          </Form.Item>
          {/* <Form.Item name='isRepeat' label='' noStyle>
            <Select allowClear placeholder='是否重复'>
              <Option value={1}>是</Option>
              <Option value={0}>否</Option>
            </Select>
          </Form.Item> */}
          <DateSelect
            allowClear={false}
            style={{ width: '6rem' }}
            labelPrefix=''
            namePrefix='time'
            initialValue={DateRangeType.Today}
            onChange={() => form.submit()}
            onCalendarChange={(v) => {
              onDateChange(v)
            }}
            disabledDate={disabledSixMonthDate}
          />
          <Button
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            onClick={() => {
              props?.export()
            }}
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
